document.addEventListener( 'DOMContentLoaded', function () {
	let page = 2;
	let loading = false;
	let noMorePosts = false; // flag to indicate whether there are more posts to load

	function loadPosts() {
		if ( ! loading && ! noMorePosts ) {
			// check the noMorePosts flag
			loading = true;
			let params = new URLSearchParams( {
				action: 'load_more_posts',
				page: page,
				query: ajax_params.query, // assuming ajax_params.query is your entire query
			} );

			fetch( ajax_params.ajax_url, {
				method: 'POST',
				headers: {
					'Content-Type':
						'application/x-www-form-urlencoded; charset=UTF-8',
				},
				body: params,
			} )
				.then( ( response ) => response.text() )
				.then( ( data ) => {
					if ( data.trim() ) {
						document
							.getElementById( 'autoload-posts-container' )
							.insertAdjacentHTML( 'beforeend', data );
						page++;
						loading = false;
					} else {
						document.getElementById( 'load-more' ).style.display =
							'none';
						noMorePosts = true; // set the noMorePosts flag
					}
				} )
				.catch( ( error ) => {
					console.error( 'There was a connection error', error );
				} );
		}
	}

	const loadMoreButton = document.getElementById( 'load-more' );

	if ( loadMoreButton ) {
		loadMoreButton.addEventListener( 'click', function () {
			loadPosts();
		} );
		window.addEventListener( 'scroll', function () {
			if (
				window.innerHeight + window.scrollY >=
					document.body.offsetHeight - 100 &&
				! loading
			) {
				loadPosts();
			}
		} );
	}
} );
